/* Pawvela one-time checkout offer (WELCOME10). */
(function () {
  var KEY = 'pv_wo_seen', PEND = 'pv_wo_pending';
  function get(k, s) { try { return (s ? sessionStorage : localStorage).getItem(k); } catch (e) { return null; } }
  function set(k, v, s) { try { (s ? sessionStorage : localStorage).setItem(k, v); } catch (e) {} }
  function del(k, s) { try { (s ? sessionStorage : localStorage).removeItem(k); } catch (e) {} }
  function money(c) { return '$' + (c / 100).toFixed(2); }
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var checkoutUrl = root + 'checkout';
  var discountUrl = root + 'discount/WELCOME10?redirect=' + encodeURIComponent('/checkout');

  /* Homepage "Get 10% off" signup: save WELCOME10 to this browser so it applies at checkout, and skip the checkout popup. */
  function homeSignup() {
    var f = document.getElementById('pv-newsletter'); if (!f) return;
    var ok = f.querySelector('.pv-news__ok'), bad = f.querySelector('.pv-news__bad');
    var taken = bad && /taken|already|exists/i.test(bad.textContent || '');
    if (!ok && !taken) return;
    set(KEY, '1');
    fetch(root + 'discount/WELCOME10', { credentials: 'same-origin' }).catch(function () {});
    fetch(root + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: 'WELCOME10' }) }).catch(function () {});
    var msg = 'You’re in! Your 10% off is saved and will apply automatically at checkout. On another device? Use code ';
    var el = ok || bad;
    el.textContent = msg; var b = document.createElement('b'); b.style.letterSpacing = '.04em'; b.textContent = 'WELCOME10'; el.appendChild(b); el.appendChild(document.createTextNode('.'));
    if (bad) { bad.className = 'pv-news__ok'; bad.setAttribute('role', 'status'); }
  }

  function init() {
    homeSignup();
    var dlg = document.getElementById('pv-wo'); if (!dlg || typeof dlg.showModal !== 'function') return;
    var s1 = dlg.querySelector('[data-pv-wo-step="1"]'), s2 = dlg.querySelector('[data-pv-wo-step="2"]');
    var form = document.getElementById('pv-wo-form'), email = document.getElementById('pv-wo-email');
    var err = dlg.querySelector('.pv-wo__err'), proceeding = false;

    function closeAndGo(url) { proceeding = true; set(KEY, '1'); try { dlg.close(); } catch (e) {} window.location.href = url; }
    function showStep(n) { s1.hidden = n !== 1; s2.hidden = n !== 2; }

    function fillTotal() {
      fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
        if (!c || !c.total_price) return;
        dlg.querySelector('[data-pv-wo-was]').textContent = money(c.total_price);
        dlg.querySelector('[data-pv-wo-now]').textContent = money(Math.round(c.total_price * 0.9));
        dlg.querySelector('[data-pv-wo-total]').hidden = false;
      }).catch(function () {});
    }

    /* After signing up the form reloads the page; reopen on step 2. */
    var ok = dlg.querySelector('[data-pv-wo-ok]') || /[?&]customer_posted=true/.test(location.search);
    var srv = dlg.querySelector('[data-pv-wo-srverr]'), srvMsg = srv ? srv.getAttribute('data-pv-wo-srverr') : '';
    var already = /taken|already|exists/i.test(srvMsg);
    if (get(PEND, true) && (ok || already)) {
      del(PEND, true); set(KEY, '1');
      fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: 'WELCOME10' }) }).catch(function () {});
      fetch(root + 'discount/WELCOME10', { credentials: 'same-origin' }).catch(function () {});
      showStep(2); fillTotal(); dlg.showModal();
    } else if (get(PEND, true) && srv) {
      del(PEND, true); showStep(1); err.textContent = 'Please check your email address and try again.'; err.hidden = false; dlg.showModal();
    }

    dlg.addEventListener('cancel', function (e) { e.preventDefault(); if (s2.hidden) closeAndGo(checkoutUrl); else closeAndGo(discountUrl); });
    dlg.querySelectorAll('[data-pv-wo-skip]').forEach(function (b) {
      b.addEventListener('click', function () { closeAndGo(s2.hidden ? checkoutUrl : discountUrl); });
    });
    var go = dlg.querySelector('[data-pv-wo-go]');
    if (go) go.addEventListener('click', function (e) { e.preventDefault(); closeAndGo(discountUrl); });
    var copy = dlg.querySelector('[data-pv-wo-copy]');
    if (copy) copy.addEventListener('click', function () {
      try { navigator.clipboard.writeText('WELCOME10').then(function () { copy.textContent = 'Copied'; setTimeout(function () { copy.textContent = 'Copy'; }, 1500); }, function () {}); } catch (e) {}
    });
    if (form) form.addEventListener('submit', function (e) {
      if (!email.value || !email.checkValidity()) { e.preventDefault(); err.hidden = false; email.focus(); return; }
      set(PEND, '1', true);
      var btn = form.querySelector('.pv-wo__cta'); if (btn) { btn.setAttribute('aria-busy', 'true'); btn.textContent = 'One moment…'; }
    });

    /* Intercept the first Check out tap. */
    document.addEventListener('click', function (e) {
      if (proceeding || get(KEY)) return;
      var t = e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
      if (!t || dlg.contains(t)) return;
      e.preventDefault(); e.stopPropagation();
      fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
        var total = c && c.total_price || 0, hasCode = c && c.discount_codes && c.discount_codes.length;
        /* Skip for empty carts, carts that already have a code, and $50–$55.55 carts that would drop below free shipping. */
        if (!total || hasCode || (total >= 5000 && total < 5556)) { closeAndGo(checkoutUrl); return; }
        showStep(1);
        if (document.querySelector('dialog[open]:not(#pv-wo)')) { try { document.querySelector('dialog[open]:not(#pv-wo)').close(); } catch (x) {} }
        dlg.showModal(); setTimeout(function () { email.focus(); }, 50);
      }).catch(function () { closeAndGo(checkoutUrl); });
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
